import { useLocation, useNavigate } from 'react-router-dom';

export const useDialogRouterState = (dialogName: string) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOpen = location.hash.includes(dialogName);

  return {
    isOpen,
    close: () => {
      if (!isOpen) {
        return;
      }
      navigate(-1);
    },
    open: () => {
      navigate({ ...location, hash: dialogName });
    },
  };
};
